import type { HelmetData } from 'react-helmet-async'

export const helmetTagNameList: Array<keyof HelmetData['context']['helmet']> = [
    'meta',
    'title',
    'link',
    'style',
    'script'
]

export enum THEME {
    DARK = 'black',
    LIGHT = 'white'
}

export enum TailwindMap {
    black = 'dark',
    white = 'light'
}

export enum ThemeEnum {
    dark = 'dark',
    light = 'light',
    black = 'black',
    white = 'white'
}

export const TempThemeMap = {
    black: TailwindMap.black,
    white: TailwindMap.white
}

export const isBrowserEnv = (() => {
    let product
    if (
        typeof navigator !== 'undefined' &&
        ((product = navigator.product) === 'ReactNative' ||
            product === 'NativeScript' ||
            product === 'NS')
    ) {
        return false
    }

    return typeof window !== 'undefined' && typeof document !== 'undefined'
})()

/**
 * 业务线 !!!! SSR 临时使用，ssr二期上线后删掉
 */
export enum BusinessLineEnum {
    /**
     * 现货/币币业务线
     */
    SPOT_BL = 1,
    CONTRACT_BL = 2,
    /**
     * 废弃
     */
    MIX_CONTRACT_BL = 3,
    OPTION_BL = 4,
    OTC_BL = 5,
    FINANCIAL_BL = 6,
    SPOT_MIX_CONTRACT = 7,
    /**
     * SUSDT混合合约，即USDT专业合约模拟盘，仅支持SUSDT保证金
     */
    S_USDT_MIX_CONTRACT_BL = 8,
    /**
     * SUSD混合合约，即混合合约的模拟盘
     */
    S_USD_MIX_CONTRACT_BL = 9,
    /**
     * USDT混合合约，即USDT专业合约，仅支持USDT保证金
     */
    USDT_MIX_CONTRACT_BL = 10,
    /**
     * USD混合合约，即混合合约
     */
    USD_MIX_CONTRACT_BL = 11,
    /**
     * USDC合约，保证金仅支持usdc，usd计价
     */
    USDC_MIX_CONTRACT_BL = 12,
    S_USDC_MIX_CONTRACT_BL = 13, // USDC模拟，保证金仅支持susdc，usd计价
    /**
     * 杠杆
     */
    MARGIN_BL = 23
}
